<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Une association pour
                                    <span>le réarmement moral / initiatives et changement international.</span>
                                    <p class="lead  text-white">Le siège se trouve à Kati Sananfara.</p>
                                </h1>
                                <!-- <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="#"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Déclaration
                                    </base-button>
                                    <base-button tag="a"
                                                 href="#"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-cloud-download-95">
                                        Reglements
                                    </base-button>
                                </div> -->
                            </div>

                            <div class="col-lg-6">
                                <h3 class="lead  text-white">
                                    <span><icon name="" gradient="warning" color="white" shadow
                                                rounded><i class="fa fa-phone"></i></icon><strong> 64 55 70 19</strong></span>
                                </h3>
                                <h3 class="lead  text-white">
                                    <span><icon name="ni ni-email-83" gradient="success" color="white" shadow
                                                rounded></icon><strong> dambeninieta@gmail.com</strong></span>
                                </h3>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">PREAMBULE
                            <!-- <span class="text-success">Design System for Bootstrap 4?</span> -->
                        </h2>
                        <p class="lead">	•	Considérant que la paix dans le monde ne peut jaillir que de la paix dans le cœur des hommes  et des femmes.</p>
                        <p class="lead">	•	Considérant qu’on ne peut réformer les structures de la société en omettant de réformer le comportement humain, c’est ainsi que les problèmes de l’humanité, notamment : scandales politiques, crises économiques, tensions interraciales, ou interethniques, destruction du tissu familial, ne peuvent valablement être résolus sans le changement profond des individus ;</p>
                        <p class="lead">	•	Considérant que l’amertume, la peur, la dépravation morale, les rivalités stériles, la corruption, l’égoïsme, l’indifférence, le tribalisme, le racisme sont autant de facteurs de sous-développement politique, économique, social ou culturel ;</p>
                        <p class="lead">	•	Considérant que les valeurs morales d’honnêteté, de pureté, de désintéressement et d’amour, prises dans la perspective de l’absolu, constituent le fondement de la société humaine, qu’elles sont à même de donner un sens à toute action personnelle, nationale ou internationale, et d’offrir à tous les hommes une espérance nouvelle dans une humanité tourmentée, menacée et affligée de tant de déraison ;</p>
                        <p class="lead">	•	Considérant que la paix, la confiance et la compréhension peuvent toujours être rétablies dès lors qu’il existe une volonté commune de pardonner et de renouveler son amour et son respect pour l’autre ;</p>
                        <p class="lead">	•	Considérant notre volonté de nous conformer à l’évolution du Réarmement Moral et Spirituel mondial qui a pris le nom d’usage : <b>INITIATIVES ET CHANGEMENT INTERNATIONAL</b> ;</p>
                        <p class="lead">	•	Convaincus que le Réarmement moral propose une qualité de vie et une philosophie d’action fondées sur les quatre critères moraux absolus d’honnêteté, de pureté, de désintéressement et d’amour, dont l’application peut provoquer des transformations et des réconciliations ;</p>
                        <p class="lead">	Nous, hommes et femmes, citoyens maliens, engagés à vivre les préceptes d’honnêteté, de pureté, de désintéressement et d’amour, tels que prônés par Franck Buchman, initiateur du mouvement du Réarmement Moral et Spirituel, convenons de créer une Association nationale de promotion de ces valeurs morales conformément aux présents statuts.</p>

                        <!-- <div class="btn-wrapper">
                            <a href="#"
                               class="btn btn-primary mb-3 mb-sm-0">Download Vue</a>
                        </div>--><br><br><br><br><br><br>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-bulb-61" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Déclaration de Création</h6>
                                    <p class="description mt-3">Nous, hommes et femmes, citoyens maliens, engagés à vivre les préceptes d’honnêteté, de pureté, de désintéressement et d’amour, avons décidé de créer une association dénommée <b>Association pour le Réarmement Moral et Spirituel / Initiatives et Changement International « Dambé ni Nieta »</b>.</p>
                                    <div>
                                        <badge type="primary" rounded>honnêteté</badge>
                                        <badge type="primary" rounded>pureté</badge>
                                        <badge type="primary" rounded>amour</badge>
                                    </div>
                                    <router-link to="/declaration" style="color: white;">
                                        <base-button tag="a" type="success" class="mt-4">
                                        Voir
                                        </base-button>
                                    </router-link>


                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-building" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Reglement Interieur</h6>
                                    <p class="description mt-3">Le règlement intérieur de l'association <b>« Dambé ni Nieta » (ARAM/IC)</b> a pour objectif de préciser les statuts de l'<b>Association pour le Réarmement Moral et spirituel / Initiatives et Changement « Dambé ni Nieta »</b>, dont l'objet est social et humanitaire.
Il sera remis à l'ensemble des membres ainsi qu'à chaque nouvel adhérent.</p>
                                    <div>
                                        <badge type="success" rounded>statuts</badge>
                                        <badge type="success" rounded>social</badge>
                                        <badge type="success" rounded>humanitaire</badge>
                                    </div>
                                    <router-link to="/reglement" style="color: white;">
                                        <base-button tag="a" type="success" class="mt-4">
                                            Voir
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-spaceship" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Statuts</h6>
                                    <p class="description mt-3">Nous, hommes et femmes, citoyens maliens, engagés à vivre les préceptes d’honnêteté, de pureté, de désintéressement et d’amour, tels que prônés par Franck Buchman, initiateur du mouvement du Réarmement Moral et Spirituel, convenons de créer une Association nationale de promotion de ces valeurs morales conformément aux présents statuts.</p>
                                    <div>
                                        <badge type="warning" rounded>désintéressement</badge>
                                        <badge type="warning" rounded>morales</badge>
                                        <badge type="warning" rounded>statuts</badge>
                                    </div>
                                    <router-link to="/statuts" style="color: white;">
                                        <base-button tag="a" type="warning" class="mt-4">
                                            Voir
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/promo-bird.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-world-2" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>L’association a pour buts</h3>
                            <!-- <p>de former des hommes et des femmes aptes à promouvoir le Réarmement moral au Mali, c’est-à-dire à établir l’entente et l’unité entre les personnes pour le perfectionnement et le développement du sens moral inné dans la conscience de chacun ;</p> -->
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">de former des hommes et des femmes aptes à promouvoir le Réarmement moral au Mali, c’est-à-dire à établir l’entente et l’unité entre les personnes pour le perfectionnement et le développement du sens moral inné dans la conscience de chacun ;</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">de prévenir et résoudre les conflits entre personnes et groupes d’origines et de cultures différentes ;</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">de soutenir des personnes en situation de détresse du fait de la guerre ou de toute autre cause de souffrance en leur redonnant dignité et sens à la vie</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">de développer la responsabilité du citoyen en s’appuyant sur des valeurs éthiques, notamment de justice, de respect de l’autre et d’intégrité ;</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">de renforcer d’une manière générale, la cohésion sociale dans toutes les sphères de la société au Mali et dans le monde.</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/img-1-1200x1000.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Design System</h4>
                                <p class="lead text-italic text-white">The Arctic Ocean freezes every winter and much of
                                    the sea-ice then thaws every summer, and that process will continue whatever
                                    happens.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>Our customers</h3>
                            <p class="lead">Don't let your uses guess by attaching tooltips and popoves to any element.
                                Just make sure you enable them first via JavaScript.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <a href="#" class="font-weight-bold text-warning mt-5">A beautiful UI Kit for impactful
                                websites</a>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-mali-flag.jpeg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-sound-wave" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded>
                                </icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Enregistrement Radio</h4>
                                <!-- <p class="text-white">ws;do</p> -->
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <label @click.prevent="audio.isPlaying ? pause(audio) : play(audio)" v-for="audio in audios" :key="audio.id">                                       
                                <div>
                                    <icon v-if="audio.isPlaying === false" name="ni ni-button-play" gradient="success" color="white" shadow
                                          rounded></icon>
                                    <icon v-if="audio.isPlaying === true" name="ni ni-button-pause" gradient="success" color="white" shadow
                                          rounded></icon>

                                          <i class="text-success">
                                                {{ audio.isPlaying ? 'Pause' : 'Ecoute' }} {{ audio.name }}</i>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">
                                    </h5>
                                </div>
                                </label>
                            </div>
                        </card>
                        <!-- <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-active-40" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">aldKSFB soildazbf</h5>
                                    <p>Twwslkdz vpisdznfsknzxv spidz;kfnsdozkxcv </p>
                                    <a href="#" class="text-warning">Apprendre plus</a>
                                </div>
                            </div>
                        </card> -->
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">Bureau exécutif de l’association</h2>
                        <!-- <p class="lead text-muted">La zone d'intervention de l'association est l’étendue du territoire national.</p> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/ceo.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">M .Moussa KEITA</span><br>
                                    <small class="h6 text-muted">Le Président</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="warning" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <!-- <base-button tag="a" href="#" type="warning" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/team-2-800x800.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Romina Hadid</span>
                                    <small class="h6 text-muted">Marketing Strategist</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="primary" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/ceo.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">M. Aboubacrine AG AMITI, Comptable</span>
                                    <small class="h6 text-muted">Le Vice-Président</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="info" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="info" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="info" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <!-- <base-button tag="a" href="#" type="info" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/ceo.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Mamoudou B. CISSE, Enseignant</span>
                                    <small class="h6 text-muted">Le Secretaire</small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="#" type="success" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="success" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="#" type="success" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <!-- <base-button tag="a" href="#" type="success" icon="fa fa-dribbble" rounded
                                                 icon-only></base-button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Build something</h2>
                        <p class="lead text-white">w;ordlnaf liwkbnsdfklsdnbf ljkwbnsdfklsbdf</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Building</h5>
                        <p class="text-white mt-3">wlqeibdqlkds ljweabsdjlabsd</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Grow</h5>
                        <p class="text-white mt-3">wlaieksbdklasfbd </p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Launch</h5>
                        <p class="text-white mt-3">w;lekandfkandsf lkwedasbfklsabdf</p>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">Do you love this awesome
                            <span class="text-success">Design System for Bootstrap 4?</span>
                        </h2>
                        <p class="lead">Cause if you do, it can be yours for FREE. Hit the button below to navigate to
                            Creative Tim where you can find the Design System in HTML. Start a new project or give an
                            old Bootstrap project a new look!</p>
                        <div class="btn-wrapper">
                            <a href="#"
                               class="btn btn-primary mb-3 mb-sm-0">Download Vue</a>
                        </div>
                        <div class="text-center">
                            <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-4">
                                    <a href="https://getbootstrap.com/" target="_blank" data-toggle="tooltip"
                                       data-original-title="Bootstrap 4 - Most popular front-end component library">
                                        <img v-lazy="'#'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.sketchapp.com/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Sketch - Digital design toolkit">
                                        <img v-lazy="'#"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.adobe.com/products/photoshop.html" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                                        <img v-lazy="'#'"
                                             class="img-fluid  opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="Vue.js - The progressive javascript framework">
                                        <img v-lazy="'#'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://angularjs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] Angular - One framework. Mobile &amp; desktop">
                                        <img v-lazy="'#'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://reactjs.org/" target="_blank" data-toggle="tooltip"
                                       data-original-title="[Coming Soon] React - A JavaScript library for building user interfaces">
                                        <img v-lazy="'#'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

    </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return  {
        audios: [
        {
            id: 'audio-20190630',
            name: 'l\'annonce',
            file: new Audio('audio/20190630.mp3'),
            isPlaying: false
        }//,
        //   {
        //     id: 'airplane-takeoff',
        //     name: 'Airplane Takeoff',
        //     file: new Audio('http://soundbible.com/mp3/airplane-takeoff_daniel_simion.mp3'),
        //     isPlaying: false
        //   }
        ],
        postBody: {}
    }
  },
  methods: {
    play (audio) {
      audio.isPlaying = true;
      audio.file.play();
    },
    
    pause (audio) {
      audio.isPlaying = false;
      audio.file.pause();
    },
    sendEmail () {
    }
  }
};
</script>
